import Dialog from './Dialog.vue'

const DialogPlugin = {

	install(Vue, defaults = {}) {
		const CONSTRUCTOR = Vue.extend(Dialog)
		const CACHE = {}

		function dialog(msg, options = {}) {
			options.message = msg
			const dialog = CACHE[options.id] || (CACHE[options.id] = new CONSTRUCTOR())
			if (!dialog.$el) {
				const vm = dialog.$mount()
				document.querySelector(options.parent || 'body').appendChild(vm.$el)
			}
			dialog.queue.push(options)
		}

		Vue.dialog = Vue.prototype.$dialog = dialog
	},
}

if (typeof window !== 'undefined' && window.Vue) {
	window.Vue.use(DialogPlugin)
}

export default DialogPlugin



// WEBPACK FOOTER //
// ./src/lib/dialog/index.js